
(function () {
    const root = document.querySelector('[data-faq-root]');
    if (!root) return;

    const input = root.querySelector('[data-faq-search]');
    const rows = Array.from(root.querySelectorAll('[data-faq-row]'));
    const empty = root.querySelector('[data-faq-empty]');

    function apply() {
        const q = (input?.value || '').trim().toLowerCase();
        let shown = 0;

        rows.forEach((r) => {
            const text = r.getAttribute('data-faq-q') || '';
            const ok = !q || text.includes(q);
            r.style.display = ok ? '' : 'none';
            if (ok) shown++;

            if (!ok) {
                const btn = r.querySelector('.mnl-faq__rowBtn');
                const ans = r.querySelector('.mnl-faq__answer');
                if (btn && ans) {
                    btn.setAttribute('aria-expanded', 'false');
                    ans.hidden = true;
                }
            }
        });

        if (empty) empty.hidden = shown !== 0;
    }

    // toggle answer
    rows.forEach((r) => {
        const btn = r.querySelector('.mnl-faq__rowBtn');
        const ans = r.querySelector('.mnl-faq__answer');
        if (!btn || !ans) return;

        btn.addEventListener('click', () => {
            const open = btn.getAttribute('aria-expanded') === 'true';
            btn.setAttribute('aria-expanded', String(!open));
            ans.hidden = open;
        });
    });

    input && input.addEventListener('input', apply);

    // open if coming with #q-handle
    if (location.hash) {
        const el = document.querySelector(location.hash);
        if (el) {
            const btn = el.querySelector('.mnl-faq__rowBtn');
            const ans = el.querySelector('.mnl-faq__answer');
            if (btn && ans) {
                btn.setAttribute('aria-expanded', 'true');
                ans.hidden = false;
                el.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
        }
    }

    apply();
})();